import { Box, Stack } from '@mui/material';
import { useField } from 'formik';
import InputWrapper from '../InputWrapper';
import Switch from '../../../global/IOSSwitch';

interface SwitchProps {
  name: string;
  label: string;
  description?: string;
  disabled?: boolean;
  tooltip?: string;
  required?: boolean;
  gap?: number;
}

function SwitchInput({
  name,
  label,
  description,
  disabled,
  tooltip,
  required,
  gap = 1.5,
}: SwitchProps) {
  const [{ value }, , { setValue, setTouched }] = useField<boolean>(
    name.toString(),
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={gap}>
      <Box flexShrink={1}>
        <InputWrapper
          label={label}
          description={description}
          isLabelMultiline
          name={name}
          tooltip={tooltip}
          required={required}
        />
      </Box>
      <Switch
        id={name}
        checked={value}
        onChange={() => {
          setValue(!value);
          setTimeout(() => setTouched(true), 0);
        }}
        disabled={disabled}
      />
    </Stack>
  );
}

export default SwitchInput;
